import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-loading-dialog',
  templateUrl: './loading-dialog.component.html',
  styleUrl: './loading-dialog.component.scss'
})
export class LoadingDialogComponent {
  @Input() visible: boolean = false;
  @Input() title?: string = undefined;
  @Input() message?: string = undefined;
}
